import { styled } from "@mui/material/styles";
import { Grid, IconButton as MuiIconButton, Button, DialogContent } from "@mui/material";

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "25px",
}));

export const IconButton = styled(MuiIconButton)({
  "& > svg": {
    width: "40px",
  },
});

export const GenerateLinkButton = styled(Button)(({ theme }) => ({
  width: "fit-content",
}));

export const GeneratedLinkContainer = styled(Grid)(({ theme }) => ({
  padding: "10px",
  display: "flex",
  border: "1px lightgray solid ",
}));
